module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._m(1)]), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_vm._v("如果活動有開通全家 FamiPort 代碼繳費方式，您可以用此方式到全臺灣的全家便利商店進行代碼繳費。"), _c('br'), _vm._v("（請注意：單筆訂單總金額不足 TWD$1,500 或超過 TWD$30,000 皆無法選用全家 FamiPort 代碼繳費方式）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("注意事項")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("請務必在繳費期限前持代碼前往全家 FamiPort 機台列印繳費單，並且完成付款。逾期訂單會被系統自動取消。"), _c('br'), _vm._v("繳費完成後的一個工作天內，可於 4Gamers 會員認證的信箱或登入 WirForce 官網，收到劃位通知。")])])]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("1. 選擇「繳費」")]), _c('div', {
    staticClass: "help-content"
  }, [_c('img', {
    attrs: {
      "src": require("assets/payment/help01.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/payment/next.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("2. 選擇「代碼繳費」")]), _c('div', {
    staticClass: "help-content"
  }, [_c('img', {
    attrs: {
      "src": require("assets/payment/help02.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/payment/next.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("3. 同意條款")]), _c('div', {
    staticClass: "help-content"
  }, [_c('img', {
    attrs: {
      "src": require("assets/payment/help03.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/payment/next.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("4. 輸入「繳費代碼」")]), _c('div', {
    staticClass: "help-content"
  }, [_c('img', {
    attrs: {
      "src": require("assets/payment/help04.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/payment/next.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("5. 確認繳費代碼")]), _c('div', {
    staticClass: "help-content"
  }, [_c('img', {
    attrs: {
      "src": require("assets/payment/help05.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/payment/next.png")
    }
  })]), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("6. 列印繳費單")]), _c('div', {
    staticClass: "help-content"
  }, [_c('img', {
    attrs: {
      "src": require("assets/payment/help06.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/payment/next.png")
    }
  })]), _c('div', {
    staticClass: "mb-40"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f66df9a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment.vue
// module id = 568
// module chunks = 1